import axios from 'axios';
import React, { useState, useEffect } from 'react';

import SelectComponent from '../common/select';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/get_pocket'
});

const productId = document.getElementById('mtm-customize').dataset.productId;

const MtmPocket = ({ setPocketData }) => {
  const [list, setList] = useState([]);

  const mtmBodyType = document.getElementById('mtm-customize').dataset.mtmBodyType;

  if (mtmBodyType == 'formal') {
    return;
  }

  useEffect(() => {
    const getList = async () => {
      const response = await client.get('?product_id=' + productId);
      setList(response.data.result);
    };
    getList();
  }, []);

  if (!list) return 'No pocket!';

  return (
    <div className="mtm-item__wrapper" id="mtm-pocket">
      <h3 className="mtm-item__title">POCKETS</h3>
      <div className="mtm-item__selects row row-cols-2 row-cols-md-3">
        {list.map((item, ind) => (
          <SelectComponent
            setOptionData={setPocketData}
            isSetAttributes
            item={item}
            ind={ind}
            name="pocket"
            key={`${item.value}-${ind}`}
          />
        ))}
      </div>
    </div>
  );
};

export default MtmPocket;
